import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "./morganscan.css";
import pavanimge from "../../Images/pavanimage.png";
import whysunwestimage from "../../Images/whysunwestimg.png";



export default function Morganscan({links, sunwestLink, pavanLink, swmcLink, pavanData}) {
  const imgCDNURL = process.env.REACT_APP_MASTERMIND_CDN_URL;
  const imgpath = process.env.REACT_APP_MAY_CDN_URL;
  const getSunWestSuccessYears = () => {
    // Sun West founded in 08/12/1980 in PST
    const foundedDate = new Date("1980-08-12T00:00:00-07:00"); // PST offset is -07:00
    const todayDate = new Date();

    // Adjust todayDate to PST timezone
    const todayPST = new Date(
      todayDate.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );

    const yearDiff = todayPST.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday =
      todayPST.getMonth() < foundedDate.getMonth() ||
      (todayPST.getMonth() === foundedDate.getMonth() &&
        todayPST.getDate() < foundedDate.getDate());

    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  };
  return (
    <>
      <div>
      
        <div className="lapisection">
          <Container>
            <Row className="lapirowrow">
              <Col sm={12} md={12} xl={7} lg={7}>
                <div className="lapidessection">
                  <p className="lapisectionhead ps-2">Why choose {htmlParser(typeof sunwestLink === "string" ? sunwestLink : "")}?</p>

                  <ul>
                    <li>Over {getSunWestSuccessYears()} Years of Excellence.</li>
                    <li> No Overlays.</li>
                    <li>
                    Choose from a wide range of loan programs at {htmlParser(typeof sunwestLink === "string" ? sunwestLink : "")}, to best suit your needs.
                    </li>
                    <li> Closings in 18 days.</li>
                    <li>
                    We service up to 93% of the loans we close. You become our family.
                    </li>
                    <li>
                      Use{" "}
                      <a
                        href={links.mobileAppURL}
                        target="_blanck"
                        rel="noreferrer"
                      >
                        {links.brandName}
                      </a>
                      , our 24/7 Personal Assistant A.I. and stay updated{" "}
                    </li>
                  </ul>
                </div>
              </Col>
              <Col sm={12} md={12} xl={5} lg={5}>
                <img src={whysunwestimage} className="lapiimag img-fluild"></img>
               
              </Col>
            </Row>
          </Container>
        </div>

        <div className="pavandesktopsection">
          <Container>
            <Row>
              <Col sm={12} md={12} xl={6} lg={6}>
                <img
                  src={pavanData?.pavanImage || pavanimge}
                  className="pavanimg img-fluild"
                  title="Pavan Agarwal"
                ></img>
              </Col>
              <Col sm={12} md={12} xl={6} lg={6} className="pavaninfsec">
                <p className="pavanname">{htmlParser(pavanData?.pavanName || pavanLink)}</p>

                <p className="pavanprofession">
                  <span className="d-none d-md-inline">{pavanData?.pavanProfession1 ? htmlParser(pavanData.pavanProfession1) : htmlParser(typeof swmcLink === "string" ? swmcLink : "")}</span>
                  <span className="d-md-none">{pavanData?.pavanProfession1 ? htmlParser(pavanData.pavanProfession1mobile || pavanData.pavanProfession1) : htmlParser(typeof swmcLink === "string" ? swmcLink : "")}</span>
                </p>
                {pavanData?.pavanProfession2 && (
                  <p className="pavanprofession">{pavanData.pavanProfession2}</p>
                )}
                {pavanData?.pavanProfession3 && (
                  <p className="pavanprofession">{pavanData.pavanProfession3}</p>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        {/* <Container>
          <Row>
            <Col>
              <p className="sunwesttext">
                Sun West Mortgage Company, Inc. is acting as the Lender and
                offers financing to qualified borrowers. Sun West Mortgage
                Company, Inc is not affiliated with any third party mentioned in
                the Website. The name and logo are owned by the respective third
                parties.
              </p>
            </Col>
          </Row>
        </Container> */}
      </div>
    </>
  );
}
